function Cache() {
    this._cacheMap = new Map();
}
Cache.prototype = {
    constructor: Cache,
    keys() {
        return this._cacheMap.keys();
    },
    get(key) {
        let item = this._cacheMap.get(key);

        return item ? item.value : undefined;
    },
    set(key, value, indate, name) {
        let item = {
            key,
            value,
            indate,
            name
        };

        if (this._cacheMap.has(key)) {
            item = Object.assign(this.get(key), item);
        }

        this._cacheMap.set(key, item);

        if (indate > 0) {
            if (item.timer) {
                clearTimeout(item.timer);
            }
            item.timer = setTimeout(() => this.remove(key), indate);
        }

        return item;
    }
}

export default new Cache()